<template>
  <GlobalWindow
    class="handle-table-dialog"
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="运营商名称" prop="name" required>
        <el-input v-model="form.name" placeholder="请输入运营商名称" v-trim maxlength="50"/>
      </el-form-item>
      <el-form-item label="登录用户名" prop="username" required v-if="title != '编辑运营商'">
        <el-input v-model="form.username" placeholder="请输入用户名" v-trim maxlength="50"/>
      </el-form-item>
      <el-form-item label="密码" prop="password" required v-if="title != '编辑运营商'">
        <el-input v-model="form.password" placeholder="请输入密码" v-trim maxlength="50" show-password/>
      </el-form-item>
      <el-form-item label="姓名" prop="realname" required v-if="title != '编辑运营商'">
        <el-input v-model="form.realname" placeholder="请输入姓名" v-trim maxlength="50"/>
      </el-form-item>
      <el-form-item label="手机号" prop="phone" required >
        <el-input v-model="form.phone" placeholder="请输入姓名" v-trim minlength="11"/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
var phoneRules = (rule, value, callback)=>{
  if(value.length != 11){
    callback(new Error('请输入正确的手机号'))
  }
}
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import icons from '@/utils/icons'
import { create, updateById} from '@/api/tenant/tenant'
export default {
  name: 'OperaMenuWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      isEdit:true,
      icons,
      // 上级菜单名称
      parentName: '',
      // 需排除选择的菜单ID
      excludeMenuId: null,
      // 表单数据
      form: {
        name: '',
        id:null,
        username:'',
        password:'',
        realname:'',
        phone:''
      },
      
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入运营商名称' }
        ],
        username: [
          { required: true, message: '请输入登录用户名' }
        ],
        password: [
          { required: true, message: '请输入密码' }
        ],
        realname: [
          { required: true, message: '请输入姓名' }
        ],
        phone: [
          { validator: phoneRules, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    /**
     * @title: 窗口标题
     * @target: 编辑的菜单对象
     * @parent: 新建时的上级菜单
     */
    open (title, target, parent) {
      this.title = title
      this.visible = true
      this.form = {
        name: '',
        id:null,
        username:'',
        password:'',
        realname:'',
        phone:''
      }
      // 新建，menu为空时表示新建菜单
      if (target == null) {
        this.isEdit = false
        this.excludeMenuId = null
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form.id = null;
          this.form.name = ''
          // this.form.username = target.username
          // this.form.password = target.password
          // this.form.realname = target.realname
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        this.excludeMenuId = target.id
        this.form={
          name:target.name,
          id:target.id,
          phone:target.managerUser.mobile
        }
      })
    },
    confirm(){
      console.log(this.form)
      if (this.form.id == null || this.form.id === '') {
        this.__confirmCreate()
        return
      }else{
        this.__confirmEdit()
        return
      }
    },
    // 确认新建
    __confirmCreate () {
      // 调用新建接口
      this.isWorking = true
      create(this.form)
        .then(() => {
          this.visible = false
          this.$tip.apiSuccess('新建成功')
          this.$emit('success')
        })
        .catch(e => {
          // this.$tip.apiSuccess(e)
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.isWorking = false
        })
    },
    // 确认修改
    __confirmEdit () {
      // 调用新建接口
      this.isWorking = true
      updateById(this.form)
        .then(() => {
          this.visible = false
          this.$tip.apiSuccess('修改成功')
          this.$emit('success')
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.isWorking = false
        })
    }
  },
  created(){
    this.config({
      api: '/tenant/tenant',
    })
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/style/variables";
$icon-background-color: $primary-color;
.global-window {
  .tip {
    margin-bottom: 12px;
    em {
      font-style: normal;
      color: $primary-color;
      font-weight: bold;
    }
  }
  // 图标
  /deep/ .form-item-icon {
    .el-form-item__content {
      height: 193px;
      overflow-y: auto;
    }
    .el-radio-group {
      background: $icon-background-color;
      padding: 4px;
      .el-radio {
        margin-right: 0;
        color: #fff;
        padding: 6px;
        &.is-checked {
          background: $icon-background-color - 30;
          border-radius: 10px;
        }
        .el-radio__input.is-checked + .el-radio__label {
          color: #fff;
        }
      }
      .el-radio__input {
        display: none;
      }
      .el-radio__label {
        padding-left: 0;
        // element-ui图标
        i {
          font-size: 30px;
        }
        // 自定义图标
        [class^="yunying-icon-"], [class*="yunying-icon-"] {
          width: 30px;
          height: 30px;
          background-size: 25px;
          vertical-align: bottom;
        }
      }
      .el-radio--small {
        height: auto;
        padding: 8px;
        margin-left: 0;
      }
    }
  }
}
</style>
